import css from "./Rotation.module.css"
import React from "react"
import { Button, Col, Row } from "reactstrap";
import { MdRotateRight } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useStore } from "store";

function Rotation({ data }) {
    const { i18n } = useTranslation()
    const t = useStore(state => state.translations)
    const rotation = useStore(state => state.rotation)
    const setRotation = useStore(state => state.setRotation)
    const setRing = useStore(state => state.setRing)
    const setTable = useStore(state => state.setTable)

    function selectRotation(rotation) {
        setRotation(rotation)
        setRing("")
        setTable("")
    }

    return (
        <Row>
            <Col sm="12">
                <div className="mb-5">
                    <Button
                        className={css.button}
                        outline
                        onClick={() => selectRotation("full")}
                        active={rotation === "full"}
                    >
                        <MdRotateRight />{' '}{t.settings.rotation.full[i18n.language]}
                    </Button>
                    <Button
                        className={css.button}
                        outline
                        onClick={() => selectRotation("pole")}
                        active={rotation === "pole"}
                    >
                        <img src={process.env.PUBLIC_URL + "/img/pole_icon.png"} alt="Pole rotation" style={{ width: "10px"}} />{' '}{t.settings.rotation.pole[i18n.language]}
                    </Button>
                </div>
                <div>
                    <p className={css.infoText}>{t.settings.rotation.fullDesc[i18n.language]}</p>
                    <p className={css.infoText}>{t.settings.rotation.poleDesc[i18n.language]}</p>
                </div>
            </Col>
        </Row>
    );
}

export default Rotation;